var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useMemo } from 'react';
import { useCallbackRef } from '../../..';
import { useAPIContext, useStoreContext } from '../../../components/Context';
import { isGeoObject, toPoint } from '../../../utils';
import { createAsyncState } from '../async/hooks';
import { getDraftRoute } from '../draft/route/selectors';
import { createTimeoutCache } from '../utils';
import { getZonePoint } from '../zone/selectors';
import { setSuggest } from './acitons';
import { getAddressType, getSuggest, toSuggestBody } from './selectors';
var useAsyncSuggest = createAsyncState('suggest');
var setCache = createTimeoutCache(500);
// функция выбирает координаты из предыдущей точки (нужно для запроса)
// за деталями см. комментарий к location в файле utils.ts функцию toSuggestBody
var usePreviousPoint = function (index, route) {
    var _a, _b;
    var state = useStoreContext()[0];
    var zonePoint = getZonePoint(state);
    var prevAddress = index > 0
        ? route[index - 1]
        : undefined;
    var pos = (_b = (_a = prevAddress === null || prevAddress === void 0 ? void 0 : prevAddress.address) === null || _a === void 0 ? void 0 : _a.geoObject) === null || _b === void 0 ? void 0 : _b.pos;
    var mayBePoint = useMemo(function () { return toPoint(pos) || zonePoint; }, [pos, zonePoint]);
    return index === 0
        ? zonePoint
        : mayBePoint;
};
export var useSuggestQuery = function (index) {
    var _a = useAsyncSuggest(index), asyncState = _a[0], actions = _a[1];
    var _b = useStoreContext(), state = _b[0], dispatch = _b[1];
    var suggestRequest = useAPIContext().suggest;
    // todo отвязать адрес от запроса, передавать в параметрах
    var route = getDraftRoute(state);
    var routePoint = route[index];
    var type = getAddressType(index, route.length);
    var suggest = getSuggest(index, state);
    var previousPoint = usePreviousPoint(index, route);
    var address = routePoint === null || routePoint === void 0 ? void 0 : routePoint.address;
    var isValid = address === null || address === void 0 ? void 0 : address.isValid;
    var part = address === null || address === void 0 ? void 0 : address.part;
    var geoObject = address === null || address === void 0 ? void 0 : address.geoObject;
    var point = address === null || address === void 0 ? void 0 : address.point;
    var request = useCallbackRef(function (addressValue, isZero) {
        if (!suggestRequest) {
            return;
        }
        var prevGeoObject = isGeoObject(addressValue)
            ? addressValue
            : undefined;
        var body = toSuggestBody(type, addressValue, previousPoint, isZero);
        actions.start();
        return suggestRequest({
            body: body,
            onSuccess: function (response, headers) {
                actions.success(response, headers);
                dispatch(setSuggest({
                    data: response,
                    idx: index,
                    key: 'suggest',
                    request: body,
                    prevGeoObject: prevGeoObject,
                }));
            },
            onError: actions.error,
        });
    }, [suggestRequest]);
    useEffect(function () {
        if (part) {
            return setCache(function () { return request(part); });
        }
    }, [part, request]);
    useEffect(function () {
        // делаем запрос только не для финального адреса
        if (geoObject && !isValid) {
            return request(geoObject);
        }
    }, [geoObject, isValid, request]);
    useEffect(function () {
        // если появляется координата из предыдущего адреса (для точки А это координата зоны),
        // то нужно получить зеро саджест для текущего адреса
        if (previousPoint) {
            return request(previousPoint, true);
        }
        // обновить нужно не только когда обновится точка, но и пользователь
        // иначе после загрузки пользователя не сработает
    }, [previousPoint, request]);
    useEffect(function () {
        if (point) {
            return request(point);
        }
    }, [point, request]);
    return __assign(__assign({}, asyncState), { suggest: suggest && (suggest.userSuggest || suggest.zeroSuggest) });
};
export var useSuggestState = function (index) {
    var state = useStoreContext()[0];
    var asyncState = useAsyncSuggest(index)[0];
    var suggest = getSuggest(index, state);
    return __assign(__assign({}, asyncState), { suggest: suggest && (suggest.userSuggest || suggest.zeroSuggest) });
};
